import { Component, OnInit, Inject, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TreatmentPlanningDataModel } from '../../treatment-planning/models/treatment-planning-data.model';
import { TreatmentPlanningService } from '../../treatment-planning/treatment-planning.service';
import { InsuranceService } from '../../insurance/insurance.service';
import { TdoClientConfigurationModel } from 'src/app/models/clients/tdo-client-configuration.model';
import { Globals } from 'src/app/globals';
import { PatientInsuranceDataModel } from 'src/app/models/patient/patient-insurance-data.model';
import { ToothConfigurationModel } from 'src/app/models/teeth/tooth-configuration.model';
import { ToothService } from 'src/app/services/tooth.service';
import { TreatmentPlanningProcedurePseudoModel } from '../../treatment-planning/models/treatment-planning-procedure-pseudo.model';
import { ARService } from '../../ar/ar.service';
import { Constants, customFormTreatmentPlanning } from 'src/app/constants';
import { CreateTransactionItemModel } from 'src/app/models/accountsReceivable/create-transaction-item.model';
import { TREATMENT_PLAN_STATUS } from 'src/app/models/constants/treatment-plan-status.model';
import { FeeItemCategoryIdEnum } from 'src/app/models/enum/fee-item-category-id.enum';
import { CaseFormsService } from '../case-forms.service';
import { DataPatientCaseWorkItemModel } from 'src/app/models/accountsReceivable/data-patient-case-work-item.model';
import { UiService } from 'src/app/services/ui.service';

@Component({
  standalone: false,
  selector: 'app-case-bill-functionality',
  templateUrl: './case-bill-functionality.component.html',
  styleUrls: ['./case-bill-functionality.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CaseBillFunctionalityComponent implements OnInit {

  caseInformation: string;
  isLoading: boolean = false;
  tabSelected: number = 0;
  selectedCaseWorkItemForm: string;

  selectedParentTreatmentPlan: TreatmentPlanningDataModel;
  tabPanelTreatmentPlanSelectedIndex: number = 0;
  currentTreatmentPlans: TreatmentPlanningDataModel[] = [];
  cfgTDOClient: TdoClientConfigurationModel;
  insuranceModels: PatientInsuranceDataModel[];

  listOfParentTreatmentPlans: TreatmentPlanningDataModel[] = [];
  teeth: ToothConfigurationModel[];
  procedurePayloads: CreateTransactionItemModel[] = [];
  selectedBillableItems: any[] = [];
  selectedTreatmentPlan: TreatmentPlanningDataModel;
  caseWorkItems: DataPatientCaseWorkItemModel[];
  insuranceOrganizations: any[] = [];
  selectedOrganization: any = null;
  activeDoctorFeeSchedule: any = {};
  feeScheduleItems: any[] = [];
  listOfFeeSchedules: any[] = [];
  
  
  constructor(
    public dialogRef: MatDialogRef<CaseBillFunctionalityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly treatmentPlanningService: TreatmentPlanningService,
    private readonly insuranceService: InsuranceService,
    public globals: Globals,
    private readonly uiService: UiService,
    private readonly toothService: ToothService,
    private readonly arService: ARService,
    private readonly caseService: CaseFormsService,
    private readonly cdr: ChangeDetectorRef,
  ){

    if (!this.toothService.allTeeth || this.toothService.allTeeth.length === 0) {
      // TODO: Things like this will need to be updated once we have a way to check settings like geoloc.
      this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((teeth) => {
        this.teeth = teeth;
      });
    } else {
      this.teeth = this.toothService.allTeeth;
    }
   
  }
  async ngOnInit() {
    try {
      if(this.data.PatientCaseId == 'null'){
        this.displayMessage('Error', 'No case selected'); 
        this.isLoading = false;
        this.safeDetectChanges();
        return;
      }
      this.isLoading = true;
      this.safeDetectChanges();
      this.caseInformation =  localStorage.getItem('SelectedCaseDescription')

      this.caseWorkItems = await this.caseService.getCaseWorkItemsByPatientCaseID(this.data.PatientCaseId).toPromise();
      console.log('caseWorkItems:', this.caseWorkItems);
      this.selectedCaseWorkItemForm = this.caseWorkItems
        .find(p => p.dataPatientCaseItemForms.some(p => p.enumCustomFormID === customFormTreatmentPlanning))
        ?.dataPatientCaseItemForms.find(p => p.enumCustomFormID === customFormTreatmentPlanning)?.CaseWorkItemFormsId;

        console.log('selectedCaseWorkItemForm:', this.selectedCaseWorkItemForm);
      this.resolveCurrentProviderDoctorID();
      this.insuranceModels = await this.insuranceService.getPatientInsuranceByPatientId(this.globals.currentPatientId).toPromise();
      
      // Get insurance organizations (same as Fee screen) - contains FeeScheduleID and patient_DocFeeScheduleID
      this.insuranceOrganizations = await this.arService.getInsuranceOrganizations(this.globals.currentPatientId).toPromise();
      
      // Load list of fee schedules (same as Fee screen) - needed for fallback logic
      this.listOfFeeSchedules = await this.arService.getListOfFeeSchedules().toPromise();
      
      
      // Set default insurance (same logic as Fee screen)
      await this.setDefaultInsurance();
      
      // Load fee schedule items based on selected insurance
      await this.loadFeeScheduleItems();
      
      //get BillableItmes
      this.selectedBillableItems = await this.arService.getBillableItems(this.data.PatientCaseId).toPromise();
      await this.loadTreatmentPlanList();

    } catch (err) {
      this.isLoading = false;
      this.safeDetectChanges();
      this.displayMessage('Error', 'Error initializing information');
    }
  }

    async loadTreatmentPlanList() 
    {
      this.isLoading = true;
      this.safeDetectChanges();
      this.listOfParentTreatmentPlans = await this.treatmentPlanningService.getTreatmentPlanList(this.globals.currentPatientId).toPromise(); 
      console.log('listOfParentTreatmentPlans:', this.listOfParentTreatmentPlans);
      this.selectedParentTreatmentPlan = this.listOfParentTreatmentPlans.find(x => x.CaseWorkItemFormsId ===  this.selectedCaseWorkItemForm )//this.listOfParentTreatmentPlans.at(0);
      console.log('selectedParentTreatmentPlan:', this.selectedParentTreatmentPlan);
      this.setParentTreatmentPlan(this.selectedParentTreatmentPlan);
    }


  saveBill() {
    if(this.procedurePayloads.length == 0){
      this.displayMessage('warning', 'Please select at least one item to bill'); 
      return;
    }
    const transactionItemID = Constants.emptyGuid; 
    this.arService.createTransactionItems(this.procedurePayloads, transactionItemID).toPromise();
    this.displayMessage('success', 'Bill saved successfully');
    this.dialogRef.close(true);

    }

  onItemCheckBox(event, item: any, index: number) {
    item.isSelected = event.checked;
    if (event.checked) 
    {
      const payload = new CreateTransactionItemModel();
      payload.PatientId = this.globals.currentPatientId;
      payload.CaseProcedureId = item.CaseProcedureId;
      payload.PatientInsuranceID = this.insuranceModels[0].PatientInsuranceID;
      payload.ProviderDoctorID = index === 1 ? item.ProviderDoctorID : this.caseWorkItems.find(p => p.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId === this.selectedTreatmentPlan.CaseWorkItemFormsId)).ProviderDoctorID;
      payload.CaseWorkItemID = index === 1 ? item.CaseWorkItemId : this.caseWorkItems.find(p => p.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId === this.selectedTreatmentPlan.CaseWorkItemFormsId)).CaseWorkItemId;
      payload.LOCID = index === 1 ? item.LOCID : this.caseWorkItems.find(p => p.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId === this.selectedTreatmentPlan.CaseWorkItemFormsId)).LOCID;
      payload.TransactionDate = new Date();
      payload.Code = item.Code;
      payload.CodeDescription = index === 1 ? (item.Description || item.ProcedureName) : item.Description;
      payload.enumFeeItemCategoryId = FeeItemCategoryIdEnum.Other;
      payload.ToothID = item.ToothID;
      
      // Find and set the CaseWorkItemToothId from the case work item teeth data
      payload.CaseWorkItemToothId = this.getCaseWorkItemToothId(payload.CaseWorkItemID, item.ToothID);
      
      // Add fee schedule information (same as Fee screen)
      if (this.selectedOrganization && this.activeDoctorFeeSchedule) {
        payload.FeeScheduleID = this.selectedOrganization.FeeScheduleID;
        payload.DocFeeScheduleID = this.activeDoctorFeeSchedule.DocFeeScheduleID;
        payload.InsuranceID = this.selectedOrganization.InsuranceID;
        payload.PatientCaseId = this.data.PatientCaseId;
        payload.WorkItemEventId = null;
        payload.ItemOrder = this.procedurePayloads.length + 1;
        
        // Get FeeScheduleItemID for this specific procedure code
        const feeScheduleItem = this.feeScheduleItems.find(feeItem => feeItem.Code === item.Code);
        payload.FeeScheduleItemID = feeScheduleItem?.FeeScheduleItemID || null;
      }
      
      this.procedurePayloads.push(payload);
    } 
    else {
      this.procedurePayloads = this.procedurePayloads.filter(p => p.Code !== item.Code && p.ToothID !== item.ToothID && p.CaseProcedureId !== item.CaseProcedureId);
    }
  }


  /**
   * Gets the CaseWorkItemToothId for a specific CaseWorkItemID and ToothID combination
   * @param caseWorkItemId - The case work item ID
   * @param toothId - The tooth ID
   * @returns The CaseWorkItemToothId or null if not found
   */
  getCaseWorkItemToothId(caseWorkItemId: string, toothId: string): string | null {
    // Find the case work item
    const caseWorkItem = this.caseWorkItems.find(cwi => cwi.CaseWorkItemId === caseWorkItemId);
    
    if (!caseWorkItem?.dataPatientCaseWorkItemTeeth) {
      return null;
    }
    const tooth = caseWorkItem.dataPatientCaseItemTeeth.find(t => t.ToothID === toothId);
    return tooth?.CaseWorkItemToothId || null;
  }

  /**
   * Sets the default insurance (same logic as Fee screen)
   */
  async setDefaultInsurance() {
    if (!this.insuranceOrganizations?.length) {
      console.warn('No insurance organizations available');
      return;
    }

    // Primary method: Find insurance with InsuranceOrder == 0 (same as Fee screen line 221)
    this.selectedOrganization = this.insuranceOrganizations.find(f => f.InsuranceOrder == 0);
    
    // Fallback method: Find insurance with isDefault == true (same as Fee screen line 1285)
    if (!this.selectedOrganization) {
      this.selectedOrganization = this.insuranceOrganizations.find(a => a.isDefault);
    }
    
    // Final fallback: Use first insurance (same as Fee screen line 236)
    if (!this.selectedOrganization) {
      this.selectedOrganization = this.insuranceOrganizations[0];
    }

    // Set up doctor fee schedule info (same as Fee screen logic)
    if (this.selectedOrganization) {
      // Use the same fallback logic as Fee screen (lines 225-398)
      await this.setupDoctorFeeScheduleWithFallback();
    }
  }

  /**
   * Resolves globals.currentProviderDoctorID from the current case's current work item
   * (e.g. the patient was opened from the calendar and Case View never ran), always
   * verifying against this case rather than trusting a possibly-stale persisted value.
   */
  resolveCurrentProviderDoctorID(): void {
    const currentCaseWorkItem = this.caseWorkItems?.find(c => c.CaseWorkItemId === this.globals.currentPatientCaseWorkItemID);
    this.globals.currentProviderDoctorID = currentCaseWorkItem?.ProviderDoctorID || null;
  }

  /**
   * Sets up doctor fee schedule with fallback logic (same as Fee screen lines 225-398)
   */
  async setupDoctorFeeScheduleWithFallback() {
    const doctorId = this.globals.currentProviderDoctorID;
    const feeScheduleID = this.selectedOrganization.FeeScheduleID;
    
    // Step 1: Check if patient_DocFeeScheduleID exists (Fee screen line 389)
    if (this.selectedOrganization.patient_DocFeeScheduleID != null) {
      const zdf = this.listOfFeeSchedules.find(f => f.ObjID == this.selectedOrganization.patient_DocFeeScheduleID);
      
      this.activeDoctorFeeSchedule = {
        DocFeeScheduleID: this.selectedOrganization.patient_DocFeeScheduleID,
        FeeScheduleID: zdf?.ParentID || feeScheduleID,
        DoctorId: doctorId
      };
      return;
    }
    
    // Step 2: Find doctor's fee schedule for this insurance (Fee screen line 225/319)
    const df = this.listOfFeeSchedules.find(f => f.ParentID == feeScheduleID && f.EntityID == doctorId);
    
    if (df != undefined) {
      this.activeDoctorFeeSchedule = {
        DocFeeScheduleID: df.ObjID,
        FeeScheduleID: df.ParentID,
        DoctorId: doctorId
      };
      return;
    }
    
    // Step 3: Get default insurance for selected FS org (Fee screen line 340)
    const dfd = this.listOfFeeSchedules.find(f => f.ParentID == feeScheduleID && f.fsType == 2);
    
    if (dfd != undefined) {
      this.activeDoctorFeeSchedule = {
        DocFeeScheduleID: dfd.ObjID,
        FeeScheduleID: dfd.ParentID,
        DoctorId: doctorId
      };
      return;
    }
    
    // Step 4: Get default for the practice (Fee screen line 354)
    const dfp = this.listOfFeeSchedules.find(f => f.fsType == 1);
    
    if (dfp != undefined) {
      // Step 4a: Check if there's one for the doctor (Fee screen line 361)
      const dfsp = this.listOfFeeSchedules.find(f => f.ParentID == dfp.ObjID && f.EntityID == doctorId);
      
      if (dfsp != undefined) {
        this.activeDoctorFeeSchedule = {
          DocFeeScheduleID: dfsp.ObjID,
          FeeScheduleID: dfsp.ParentID,
          DoctorId: doctorId
        };
        return;
      }
      
      // Step 4b: Practice default fallback (Fee screen line 373)
      const dfspd = this.listOfFeeSchedules.find(f => f.ParentID == dfp.ObjID && f.fsType == 2);
      
      if (dfspd != undefined) {
        this.activeDoctorFeeSchedule = {
          DocFeeScheduleID: dfspd.ObjID,
          FeeScheduleID: dfspd.ParentID,
          DoctorId: doctorId
        };
        return;
      }
    }
    
    // If all else fails, use what we have
    this.activeDoctorFeeSchedule = {
      DocFeeScheduleID: null,
      FeeScheduleID: feeScheduleID,
      DoctorId: doctorId
    };
  }

  /**
   * Loads fee schedule items (same as Fee screen getFeeScheduleChildItems)
   */
  async loadFeeScheduleItems() {
    try {
      if (!this.activeDoctorFeeSchedule?.DocFeeScheduleID) {
        return;
      }

      // Same API call as Fee screen (ar-create-transaction.component.ts line 218)
      this.feeScheduleItems = await this.arService.getFeeScheduleChildItems(
        this.activeDoctorFeeSchedule.DocFeeScheduleID
      ).toPromise();

    } catch (error) {
      this.feeScheduleItems = [];
    }
  }

  displayMessage(type, message) {
    this.uiService.displayMessage(type, message);
  }

  cancel(payload) {
    this.dialogRef.close(payload);
  }

  setParentTreatmentPlan(model: TreatmentPlanningDataModel) {
    console.log('setParentTreatmentPlan: model:', model);
    if (!model){
      console.log('setParentTreatmentPlan: model is null');
      this.isLoading = false;
      this.safeDetectChanges();
      return;
    }
    this.selectedParentTreatmentPlan = model;
    this.tabPanelTreatmentPlanSelectedIndex = 0;
    this.isLoading = true;
    this.safeDetectChanges();

    this.treatmentPlanningService.getTreatmentPlan(this.selectedParentTreatmentPlan.TreatmentPlanningID).subscribe((plans) => {
      this.currentTreatmentPlans = plans.filter(p => p.enumTreatmentPlanStatusID.toLocaleUpperCase() === TREATMENT_PLAN_STATUS.AcceptedByPatient);
      this.setupPlanTeeth();

      if (this.currentTreatmentPlans && this.currentTreatmentPlans.length > 0) {
        this.selectedTreatmentPlan = this.currentTreatmentPlans[0];
        this.selectedTreatmentPlan.Procedures = this.currentTreatmentPlans.map(p => p.Procedures).reduce((a, b) => a.concat(b));

        // Sort procedures by creation timestamp to maintain FIFO order
        // Precompute timestamps to avoid repeated Date parsing during sort
        const proceduresWithTimestamp = this.selectedTreatmentPlan.Procedures.map((p, index) => {
          let timestamp = 0; // Default fallback timestamp

          if (p.xauditCreatedOn) {
            const parsedDate = new Date(p.xauditCreatedOn);
            if (!isNaN(parsedDate.getTime())) {
              timestamp = parsedDate.getTime();
            } else {
              // Invalid date: use index as fallback to maintain some order
              timestamp = index;
            }
          } else {
            // Null/undefined date: use index as fallback
            timestamp = index;
          }

          return {
            procedure: p,
            timestamp: timestamp
          };
        });

        proceduresWithTimestamp.sort((a, b) => a.timestamp - b.timestamp);
        this.selectedTreatmentPlan.Procedures = proceduresWithTimestamp.map(p => p.procedure);
      }
      if (this.selectedTreatmentPlan?.Procedures) {
        this.selectedBillableItems = this.selectedBillableItems.filter(p => !this.selectedTreatmentPlan.Procedures.find(p2 => p2.Code === p.Code && p2.ToothID === p.ToothID));
      }
      setTimeout(() => {
        this.isLoading = false;
        this.safeDetectChanges();
      }, 50);
    }, err => {
      setTimeout(() => {
        this.isLoading = false;
        this.safeDetectChanges();
      }, 50);
      this.displayMessage('Error', 'Something went wrong');
    });
  }


  setupPlanTeeth() {
    for (const plan of this.currentTreatmentPlans) {
      for (const proc of plan.Procedures) {
        proc.toothModel = this.teeth.find(p => p.ToothId === proc.ToothID);
      }
    }
  }

  getOriginalDoctorsFee(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.Fee != null) {
      return procedure.Fee.toString();
    } else {
      return '0.00';
    }
  }

  getFeeAdjusted(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceAdjusted !== null && procedure.PriceAdjusted !== 0) {
      return Number(procedure.PriceAdjusted).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getInsuranceEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceTotalDueByInsurance != null && procedure.PriceTotalDueByInsurance !== 0) {
      return Number(procedure.PriceTotalDueByInsurance).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getDeductible(procedure: TreatmentPlanningProcedurePseudoModel): string {
    // Currently deductible isn't being brought across
    if (procedure.Deductible != null) {
      return Number(procedure.Deductible).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  getPaymentEstimate(procedure: TreatmentPlanningProcedurePseudoModel): string {
    if (procedure.PriceDueByPatient !== null && procedure.PriceDueByPatient !== 0) {
      return Number(procedure.PriceDueByPatient).toFixed(2).toString();
    } else {
      return '0.00';
    }
  }

  private safeDetectChanges() {
    const viewRef = this.cdr as any;
    if (!viewRef.destroyed) {
      this.cdr.detectChanges();
    }
  }

}
